module.exports = __webpack_public_path__ + "img/dirt-road.f3929038.webp";